module.exports = __webpack_public_path__ + "static/media/27.09e44f19.mp3";